import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-report",
  "use": "icon-report-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-report\"><path d=\"M960 64v800l-128-85.312V896H256l-192 96v-768h128V64h768zM192 288H128v600.384L240.896 832H768v-96H192v-448zM896 128H256v544h531.392L896 744.32V128z m-192 320v64H384V448h320z m64-192v64H384V256h384z\" p-id=\"2689\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol